import React from 'react';
import { Box, Divider, Paper, Typography } from '@mui/material';
import { Team } from '@tassomutuo-backoffice/types';
import { CtaButton } from '@tassomutuo-backoffice/ui';
import MailOutlineIcon from '@mui/icons-material/MailOutline';

interface IProps {
  team: Team;
  onNotifyTeamClick: () => void;
}

const TeamDetails = ({ team, onNotifyTeamClick }: IProps) => {
  return (
    <Paper sx={{ bgcolor: 'white', p: 2, borderRadius: 2, mt: 4 }}>
      <Box
        sx={{
          display: 'flex',
          gap: 8,
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
          Team
        </Typography>
        <CtaButton variant="contained" onClick={onNotifyTeamClick}>
          <MailOutlineIcon />
          <Typography pl={1}>Notifica</Typography>
        </CtaButton>
      </Box>
      <Divider sx={{ my: 2 }} />

      <Box sx={{ display: 'flex', gap: 8 }}>
        <Box>
          <Typography variant="body1">
            Team Manager: {team.teamManager.name}
          </Typography>
          <Typography variant="body1">
            Email: {team.teamManager.email}
          </Typography>
        </Box>
        <Box>
          <Typography variant="body1">
            Totale Leads non aggiornate: {team.statistics?.oldestLead}
          </Typography>
        </Box>
      </Box>
    </Paper>
  );
};

export default TeamDetails;
